export enum Status {
  REJECTED = 'Rejected',
  NEW = 'New',
  INDEXED = 'Indexed',
}
